import React, { Fragment } from 'react'

const Affirm = ({ product }) => {
    const firstSkuWithInventory = (product?.skus || []).find(
        (sku) => sku.inventoryLevel > 0
    )

    const price = firstSkuWithInventory?.price
    const compareAtPrice = firstSkuWithInventory?.listPrice

    const vendor = product?.brand

    return (
        <Fragment>
            {vendor === 'Monica + Andy' && product ? (
                <div className="afterpay-messaging !text-xs !font-normal top-2 w-full">
                    <square-placement
                        data-mpid="3d7b31a3-59fb-465b-bb70-6c38f4f2f952"
                        data-placement-id="ad537775-3d6c-4235-8f2c-af51f7cb5fd2"
                        data-page-type="product"
                        data-amount={
                            compareAtPrice
                                ? parseFloat(compareAtPrice).toFixed(2)
                                : parseFloat(price).toFixed(2)
                        }
                        data-currency="USD"
                        data-consumer-locale="US"
                        data-item-skus={
                            firstSkuWithInventory && firstSkuWithInventory.id
                                ? firstSkuWithInventory.id
                                : ''
                        }
                        data-item-categories={
                            product && product.productType
                                ? product.productType
                                : ''
                        }
                        data-is-eligible="true"
                    ></square-placement>
                </div>
            ) : null}
        </Fragment>
    )
}
export default Affirm
